import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    text: {
      primary: "#111827",
      secondary: "#374151",
      disabled: "#374151",
    },
  },
  typography: {
    fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    button: { textTransform: "none", fontWeight: 600 },
    h1: { fontSize: "2rem", fontWeight: 700 },
    h2: { fontSize: "1.75rem", fontWeight: 700 },
    h3: { fontSize: "1.5rem", fontWeight: 700 },
    h4: { fontSize: "1.25rem", fontWeight: 700 },
    h5: { fontSize: "1.125rem", fontWeight: 700 },
    h6: { fontSize: "1rem", fontWeight: 600 },
  },
  components: {
    MuiTabs: {
      defaultProps: {
        variant: "scrollable",
        scrollButtons: "auto",
        allowScrollButtonsMobile: true,
      },
      styleOverrides: {
        root: ({ theme: t }) => ({
          minHeight: 48,
          [t.breakpoints.up("sm")]: { minHeight: 56 },
        }),
      },
    },
    // Tables grow with their rows and the page scrolls, not a frame inside the page (29 Oct
    // meeting: "scrolling inside, it's difficult"). Wide tables still scroll sideways. A table
    // that needs its own scroll box (a panel in a dialog) sets maxHeight itself.
    MuiTableContainer: {
      styleOverrides: {
        root: {
          overflowX: "auto",
        },
      },
    },
    // Phones: MUI's 32px dialog margins leave too little of a 375px screen.
    MuiDialog: {
      styleOverrides: {
        paper: ({ theme: t }) => ({
          [t.breakpoints.down("sm")]: {
            margin: 12,
            width: "calc(100% - 24px)",
            maxHeight: "calc(100% - 24px)",
          },
        }),
      },
    },
    MuiDialogTitle: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          [t.breakpoints.down("sm")]: { paddingLeft: 16, paddingRight: 16 },
        }),
      },
    },
    MuiDialogActions: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          [t.breakpoints.down("sm")]: {
            flexWrap: "wrap",
            gap: 8,
            paddingLeft: 16,
            paddingRight: 16,
            "& > :not(style) ~ :not(style)": { marginLeft: 0 },
          },
        }),
      },
    },
    MuiDialogContent: {
      styleOverrides: {
        root: ({ theme: t }) => ({
          "& .MuiTableContainer-root": {
            maxHeight: "min(70vh, calc(100vh - 160px))",
            overflow: "auto",
            scrollbarGutter: "stable",
          },
          [t.breakpoints.down("sm")]: { paddingLeft: 16, paddingRight: 16 },
        }),
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          "&:has(> .MuiTableContainer-root)": {
            overflow: "visible",
          },
        },
      },
    },
  },
});

export default theme;
